import { useState, useEffect } from 'react';

/**
 * 모바일 여부를 감지하는 커스텀 훅
 * @param breakpoint 모바일 판단 기준 너비 (기본: 768px)
 * @returns 현재 화면이 모바일인지 여부
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
